import { _, React, ts } from '_core';

import Chart from './chart';
import { DraftParams, Params } from './types';

type BacktestStatisticsVsTimeProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  mode: ts.enums.CHART_MODE_ENUM;
  params: Params;
  setParams: (_p: DraftParams) => void;
  title: string;

  fullScreen?: boolean;
  context?: ts.types.backtest.BacktestAnaylsisContext;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  widgetPaths?: Record<'backtest_statistics_vs_time', string>;
};

const BacktestStatisticsVsTime = ({
  id,
  readOnly,
  widgetKey,
  loadWidgetData,
  widgetPaths,
  params,
  fullScreen,
  context,
  title,
}: BacktestStatisticsVsTimeProps) => {
  // We won't enable benchmark for basket on this widget, as we don't want to have
  // a wat to set them on the definition
  const hasBenchmark = React.useMemo(() => (params.isBasket ? false : !_.isEmpty(context?.definition?.benchmark)), []);

  return (
    <Chart
      id={id}
      readOnly={readOnly}
      widgetKey={widgetKey}
      loadWidgetData={loadWidgetData}
      portfolios={widgetPaths['backtest_statistics_vs_time']}
      fullScreen={fullScreen}
      params={params}
      frequency={context?.definition?.frequency as ts.enums.FREQUENCY_ENUM}
      hasBenchmark={hasBenchmark}
      title={title}
      isBasket={params.isBasket}
    />
  );
};

export default BacktestStatisticsVsTime;
